export const SETTINGS = {
	disabled: false,
	listPosition: 'bottom left',
	noAutoHighlight: false,
	stayOpen: false,
	theme: 'ba-Dropdown'
};
